import { Paragraph } from '@/shared/components'
import { intlTag, useLocale, useT } from '@/shared/i18n'

export interface NotificationContextProps {
  case_label?: string | null
  due_on?: string | null
}

export function NotificationContext({ case_label, due_on }: NotificationContextProps) {
  const t = useT()
  const locale = useLocale()
  return (
    <>
      {case_label && <Paragraph asChild><span className="notification-context">{case_label}</span></Paragraph>}
      {due_on && (
        <Paragraph asChild><span className="notification-deadline">
          {t('portal.notifications.context.deadline', {
            date: new Date(due_on).toLocaleDateString(intlTag(locale), {
              day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
            }),
          })}
        </span></Paragraph>
      )}
    </>
  )
}
